//Vite no longer globally exposes jQuery, so we need to import it manually
import $ from 'jquery';
window.$ = window.jQuery = $;
